import { Dispatch, Action } from 'redux';
import { Role } from '../reducers/roles.reducer'
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
// import { NotificationManager } from 'react-notifications';
import { getRoleAPI, getRolesAPI, addRoleAPI, editRoleAPI, deleteRoleAPI } from '../../config/config'


// Action types
export const GET_ROLES_REQUEST = 'GET_ROLES_REQUEST';
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS';
export const GET_ROLES_FAILURE = 'GET_ROLES_FAILURE';

export const GET_ROLE_REQUEST = 'GET_ROLE_REQUEST';
export const GET_ROLE_SUCCESS = 'GET_ROLE_SUCCESS';
export const GET_ROLE_FAILURE = 'GET_ROLE_FAILURE';

export const ADD_ROLE_REQUEST = 'ADD_ROLE_REQUEST';
export const ADD_ROLE_SUCCESS = 'ADD_ROLE_SUCCESS';
export const ADD_ROLE_FAILURE = 'ADD_ROLE_FAILURE';

export const EDIT_ROLE_REQUEST = 'EDIT_ROLE_REQUEST';
export const EDIT_ROLE_SUCCESS = 'EDIT_ROLE_SUCCESS';
export const EDIT_ROLE_FAILURE = 'EDIT_ROLE_FAILURE';

export const DELETE_ROLE_REQUEST = 'DELETE_ROLE_REQUEST';
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS';
export const DELETE_ROLE_FAILURE = 'DELETE_ROLE_FAILURE';

export const SET_ADD_ROLE_POPUP = 'SET_ADD_ROLE_POPUP';
export const SET_EDIT_ROLE_POPUP = 'SET_EDIT_ROLE_POPUP';
export const SET_DELETE_ROLE_POPUP = 'SET_DELETE_ROLE_POPUP';

export const RESET_ROLE_STATE = 'RESET_ROLE_STATE'

export interface AddRoleProps {
  name: string;
  privileges: PrivilegesProps[];
}

export interface EditRoleProps {
  name: string;
  privileges: PrivilegesProps[];
}

export interface PrivilegesProps {
  model: string;
  actions: string[]
}


interface GetRolesRequest extends Action<typeof GET_ROLES_REQUEST> { }
interface GetRolesSuccess extends Action<typeof GET_ROLES_SUCCESS> {
  payload: Role[]
}
interface GetRolesFailure extends Action<typeof GET_ROLES_FAILURE> {
  payload: string
}

interface GetRoleRequest extends Action<typeof GET_ROLE_REQUEST> { }
interface GetRoleSuccess extends Action<typeof GET_ROLE_SUCCESS> {
  payload: Role
}
interface GetRoleFailure extends Action<typeof GET_ROLE_FAILURE> {
  payload: string
}

interface AddRoleRequest extends Action<typeof ADD_ROLE_REQUEST> { }
interface AddRoleSuccess extends Action<typeof ADD_ROLE_SUCCESS> { }
interface AddRoleFailure extends Action<typeof ADD_ROLE_FAILURE> {
  payload: string
}

interface EditRoleRequest extends Action<typeof EDIT_ROLE_REQUEST> { }
interface EditRoleSuccess extends Action<typeof EDIT_ROLE_SUCCESS> { }
interface EditRoleFailure extends Action<typeof EDIT_ROLE_FAILURE> {
  payload: string
}

interface DeleteRoleRequest extends Action<typeof DELETE_ROLE_REQUEST> { }
interface DeleteRoleSuccess extends Action<typeof DELETE_ROLE_SUCCESS> { }
interface DeleteRoleFailure extends Action<typeof DELETE_ROLE_FAILURE> {
  payload: string
}

interface SetAddPLanPopUp extends Action<typeof SET_ADD_ROLE_POPUP> {
  payload: boolean;
}

interface SetEditPLanPopUp extends Action<typeof SET_EDIT_ROLE_POPUP> {
  payload: boolean;
}

interface SetDeletePLanPopUp extends Action<typeof SET_DELETE_ROLE_POPUP> {
  payload: boolean;
}

interface ResetRoleState extends Action<typeof RESET_ROLE_STATE> {}

export type ActionTypes = GetRolesRequest | GetRolesSuccess | GetRolesFailure
  | GetRoleRequest | GetRoleSuccess | GetRoleFailure
  | AddRoleRequest | AddRoleSuccess | AddRoleFailure
  | EditRoleRequest | EditRoleSuccess | EditRoleFailure
  | DeleteRoleRequest | DeleteRoleSuccess | DeleteRoleFailure
  | SetAddPLanPopUp | SetEditPLanPopUp | SetDeletePLanPopUp
  | ResetRoleState

// Action creators
const getRolesRequest = (): GetRolesRequest => ({ type: GET_ROLES_REQUEST });
const getRolesSuccess = (data: Role[]): GetRolesSuccess => ({ type: GET_ROLES_SUCCESS, payload: data });
const getRolesFailure = (error: string): GetRolesFailure => ({ type: GET_ROLES_FAILURE, payload: error });

const getRoleRequest = (): GetRoleRequest => ({ type: GET_ROLE_REQUEST });
const getRoleSuccess = (data: Role): GetRoleSuccess => ({ type: GET_ROLE_SUCCESS, payload: data });
const getRoleFailure = (error: string): GetRoleFailure => ({ type: GET_ROLE_FAILURE, payload: error });

const addRoleRequest = (): AddRoleRequest => ({ type: ADD_ROLE_REQUEST });
const addRoleSuccess = (): AddRoleSuccess => ({ type: ADD_ROLE_SUCCESS });
const addRoleFailure = (error: string): AddRoleFailure => ({ type: ADD_ROLE_FAILURE, payload: error });

const editRoleRequest = (): EditRoleRequest => ({ type: EDIT_ROLE_REQUEST });
const editRoleSuccess = (): EditRoleSuccess => ({ type: EDIT_ROLE_SUCCESS });
const editRoleFailure = (error: string): EditRoleFailure => ({ type: EDIT_ROLE_FAILURE, payload: error });

const deleteRoleRequest = (): DeleteRoleRequest => ({ type: DELETE_ROLE_REQUEST });
const deleteRoleSuccess = (): DeleteRoleSuccess => ({ type: DELETE_ROLE_SUCCESS });
const deleteRoleFailure = (error: string): DeleteRoleFailure => ({ type: DELETE_ROLE_FAILURE, payload: error });

const setAddRolePopup = (value: boolean): SetAddPLanPopUp => ({ type: SET_ADD_ROLE_POPUP, payload: value });
const setEditRolePopup = (value: boolean): SetEditPLanPopUp => ({ type: SET_EDIT_ROLE_POPUP, payload: value });
const setDeleteRolePopup = (value: boolean): SetDeletePLanPopUp => ({ type: SET_DELETE_ROLE_POPUP, payload: value });

const resetRoleState = (): ResetRoleState => ({type:RESET_ROLE_STATE})


// Async action creators
const getRoles = () => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(getRolesRequest());
      const response = await getRolesAPI()
      dispatch(getRolesSuccess(response?.data?.adminRoles || []))

    } catch (error: any) {
      console.log('error', error)
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(getRolesFailure(error.message));
    }
  };
};

const getRole = (uuid: string) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(getRoleRequest());
      const response = await getRoleAPI(uuid)
      dispatch(getRoleSuccess(response?.data?.adminRole || {}))

    } catch (error: any) {
      console.log('error', error)
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(getRoleFailure(error.message));
    }
  };
};

const addRole = (data: AddRoleProps): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    try {
      dispatch(addRoleRequest());

      const response = await addRoleAPI(data)
      dispatch(addRoleSuccess());
      dispatch(getRoles()); // Call the getRoles action after adding a role
      dispatch(setAddRolePopup(false))
    } catch (error: any) {
      console.log('error', error);
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(addRoleFailure(error.message));
    }
  };
};

const editRole = (data: AddRoleProps, uuid: string): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  const token = window.localStorage.getItem('token');
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    try {
      dispatch(editRoleRequest());
      const response = await editRoleAPI(data, uuid)
      dispatch(editRoleSuccess());
      dispatch(getRoles()); // Call the getRoles action after adding a role
      dispatch( updateEditRolePopup(false))
    } catch (error: any) {
      console.log('error', error);
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(editRoleFailure(error.message));
    }
  };
};

const deleteRole = (uuid: string): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    try {
      dispatch(deleteRoleRequest());
      const response = await deleteRoleAPI(uuid)
      dispatch(deleteRoleSuccess());
      dispatch(getRoles()); // Call the getRoles action after adding a role
      dispatch(updateDeleteRolePopup(false))
    } catch (error: any) {
      console.log('error', error);
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(deleteRoleFailure(error.message));
    }
  };
};

const updateAddRolePopup = (value: boolean): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(setAddRolePopup(value))
  };
}

const updateEditRolePopup = (value: boolean): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(setEditRolePopup(value))
  };
}

const updateDeleteRolePopup = (value: boolean): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(setDeleteRolePopup(value))
  };
}

const resetAll = (): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(resetRoleState())
  };
}


const actions = {
  getRoles,
  addRole,
  editRole,
  getRole,
  deleteRole,
  updateAddRolePopup,
  updateEditRolePopup,
  updateDeleteRolePopup,
  resetAll
}

export default actions
